import React from "react";
import moment from 'moment';
import {
  Button,
  List,
  ExportButton,
  RefreshButton,
  TopToolbar,
  Datagrid,
  TextField,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  DateField,
  ShowButton,
  Filter,
  TextInput,
  GET_ONE,
  useRecordContext,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";

const DeliveryStatus = () => {
  const record = useRecordContext();
  console.log('delivery record', record)
  console.log('0000000', document.getElementById(`myButton_${record.id}`), record.updated_at === record.created_at)
  return (
    record.delivery_info ? <span className={`delivery_status_${record.id}`}>{record.delivery_info}</span> : <span><p className={`delivery_status_${record.id} hyphen-bold`}>-</p></span>
  )
}

const ButtonAction = () => {
  const record = useRecordContext();
  console.log("hello record", record);
  const [apiLoading, setApiLoading] = React.useState(false);
  const [delived, setDelived] = React.useState('');
  const apiCall = () => {
    setApiLoading(true);
    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;
    const options = {};
    //   options.method = "POST";
    options.headers = {
      Authorization: userData._token,
    };
    //   options.body = formData;

    const url = `${RUN_TIME_API_ENDPOINT}/check_sms_status?business_id=${record.business_id}&id=${record.id}`;
    fetch(url, options)
      .then((res) => {
        if (res.status === 401) {
          // localStorage.removeItem("__state");
          // window.location.href = "#/login";
          setDelived(false);
        }
        return res.json();
      })
      .then((json) => {
        setApiLoading(false);
        console.log("json==>", json);
        // const msg = json.data[0].message;
        // this.setState({
        //     showModal: true,
        //     message: msg,
        //     showLoader: false
        // });
        const delivery_s = `delivery_status_${record.id}`;
        console.log('hello deliver', delivery_s, moment(json.data.updated_at).format('DD/MM/YYYY, H:mm:ss a'))
        if(json.data.delivery_info=== 'Delivered'){
            setDelived('Delivered');
            document.querySelector(`.delivery_status_${record.id}`).textContent = 'Delivered';
            document.querySelector(`.updated_date_${record.id}`).textContent = moment(json.data.updated_at).format('DD/MM/YYYY, H:mm:ss a');
        } else if(json.data.delivery_info === 'NonDelivered') {
            setDelived('Not Delivered');
            document.querySelector(`.delivery_status_${record.id}`).textContent = 'Not Delivered';
            document.querySelector(`.updated_date_${record.id}`).textContent = moment(json.data.updated_at).format('DD/MM/YYYY, H:mm:ss a');
        } else if(json.data.delivery_info === 'no delivery report found') {
            document.querySelector(`.delivery_status_${record.id}`).textContent = 'no delivery report found';
            document.querySelector(`.updated_date_${record.id}`).textContent = moment(json.data.updated_at).format('DD/MM/YYYY, H:mm:ss a');
        } else {
          document.querySelector(`.delivery_status_${record.id}`).textContent = '-';
          document.querySelector(`.updated_date_${record.id}`).textContent = moment(json.data.updated_at).format('DD/MM/YYYY, H:mm:ss a');
      }
        console.log("error json ===>", json);
        // window.location.reload();
      })
      .catch((error) => {
        setApiLoading(false);
        // this.setState({
        //     showModal: true,
        //     showLoader: false,
        //     message: 'Something went wrong. Please try again.'
        // })
        setDelived(false);
        console.log("eroror", error);
      });
  };

  return (
    <div
      // component={Link}
      onClick={apiCall}    
    >
      <div>
        <button className="check-status-btn" disabled={apiLoading} id={`myButton_${record.id}`}>
          Check Status
        </button>
      </div>
    </div>
  );
};

const DateTimeSentAt =()=>{
 const record = useRecordContext();
 return(
   <div>
     <p>{moment(record.message_sent_at).format('DD/MM/YYYY, H:mm:ss a')}</p>
   </div>
 )
}

const LastStatusFetch = () => {
  const record = useRecordContext();
  return (
    document.querySelector(`.delivery_status_${record.id}`)?.textContent !== '-' ? <p className={`updated_date_${record.id}`}>{moment(record.updated_at).format('DD/MM/YYYY, H:mm:ss a')}</p> : <p className={`updated_date_${record.id} hyphen-bold`}>-</p>
  )
}

const SMSdelivery  = (props) => {
    return (
      <React.Fragment>
        <Scrollbars class="scroll-container">
          <List
            {...props}
            exporter={false}
            sort={{ field: "created_at", order: "DESC" }}
            title="SMS Delivery"
            bulkActionButtons={false}
            Show={false}
          >
            <Datagrid bulkActionButtons={false}>
              <TextField label="Business" source="business" />
              <TextField
                label="Phone"
                source="phone"
                sortable={false}
                allowEmpty
              />
              <TextField label="SMS Text" source="sms_text" />
              <DateTimeSentAt label="SMS Sent At" addLable/>
              <ButtonAction label="Action" addLable />
              <DeliveryStatus label="Delivery Status" />
              <LastStatusFetch label="Last Status Fetch At"/>
              <TextField label="Message Id" source="message_id" />
            </Datagrid>
          </List>
        </Scrollbars>
      </React.Fragment>
    );
  
}

export default SMSdelivery;
